<template>
  <v-form v-model="valid" ref="form" class="form">
    <v-container class="pa-4">
      <v-row>
        <v-col cols="12" md="6">
          <h1>ДАННЫЕ ПОКУПАТЕЛЯ</h1>
          <v-text-field
            :value="brokerLastName"
            v-on:input="$emit('updateBrokerLastName', ($event || '').trim())"
            :counter="40"
            :rules="[rules.required, rules.counter]"
            label="ФАМИЛИЯ"
            placeholder="ИВАНОВ"
            type="input"
            filled
            dense
            clearable
            required
          ></v-text-field>

          <v-text-field
            dense
            filled
            :value="brokerFirstName"
            v-on:input="$emit('updateBrokerFirstName', ($event || '').trim())"
            :rules="[rules.required, rules.counter]"
            :counter="40"
            label="ИМЯ"
            placeholder="ИВАН"
            type="input"
            clearable
            required
          ></v-text-field>

          <v-text-field
            :value="brokerMiddleName"
            v-on:input="$emit('updateBrokerMiddleName', ($event || '').trim())"
            :rules="[rules.required, rules.counter]"
            :counter="40"
            label="ОТЧЕСТВО"
            placeholder="ИВАНОВИЧ"
            type="input"
            filled
            dense
            clearable
            required
          ></v-text-field>

          <v-text-field
            :value="brokerEmail"
            v-on:input="$emit('updateBrokerEmail', ($event || '').trim())"
            :rules="[rules.required, rules.email]"
            :counter="40"
            prepend-inner-icon="mdi-email-outline"
            label="E-MAIL"
            placeholder="ivanovivan@mail.ru"
            type="email"
            dense
            filled
            clearable
            required
          ></v-text-field>

          <v-text-field
            :value="brokerPhone"
            v-on:input="$emit('updateBrokerPhone', ($event || '').trim())"
            :rules="[rules.required, rules.phone]"
            :counter="40"
            label="КОНТАКТНЫЙ ТЕЛЕФОН"
            placeholder="+7916-455-33-33"
            prepend-inner-icon="mdi-phone-outline"
            :succes-messages="['Ok']"
            type="phone"
            dense
            filled
            clearable
            required
          ></v-text-field>
        </v-col>

        <v-col cols="12" md="6">
          <h1>ДЛЯ КОГО {{ requestType }}</h1>

          <v-text-field
            :value="lastName"
            v-on:input="$emit('updateLastName', ($event || '').trim())"
            :counter="40"
            :rules="[rules.required, rules.counter]"
            label="ФАМИЛИЯ"
            placeholder="ИВАНОВ"
            type="input"
            filled
            dense
            clearable
            required
          ></v-text-field>

          <v-text-field
            dense
            filled
            :value="firstName"
            v-on:input="$emit('updateFirstName', ($event || '').trim())"
            :rules="[rules.required, rules.counter]"
            :counter="40"
            label="ИМЯ"
            placeholder="ИВАН"
            type="input"
            clearable
            required
          ></v-text-field>

          <v-text-field
            :value="middleName"
            v-on:input="$emit('updateMiddleName', ($event || '').trim())"
            :rules="[rules.required, rules.counter]"
            :counter="40"
            label="ОТЧЕСТВО"
            placeholder="ИВАНОВИЧ"
            type="input"
            filled
            dense
            clearable
            required
          ></v-text-field>

          <v-text-field
            :value="email"
            v-on:input="$emit('updateEmail', ($event || '').trim())"
            :rules="[rules.required, rules.email]"
            :counter="40"
            prepend-inner-icon="mdi-email-outline"
            label="E-MAIL"
            placeholder="ivanovivan@mail.ru"
            type="email"
            dense
            filled
            clearable
            required
          ></v-text-field>

          <v-text-field
            :value="phone"
            v-on:input="$emit('updatePhone', ($event || '').trim())"
            :rules="[rules.required, rules.phone]"
            :counter="40"
            label="КОНТАКТНЫЙ ТЕЛЕФОН"
            placeholder="+7916-455-33-33"
            prepend-inner-icon="mdi-phone-outline"
            :succes-messages="['Ok']"
            type="phone"
            dense
            filled
            clearable
            required
          ></v-text-field>

          <v-menu
            ref="menu"
            v-model="menu"
            :close-on-content-click="false"
            bottom
            origin="center center"
            transition="scale-transition"
            min-width="auto"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                :value="dateInfo"
                label="ДЕНЬ РОЖДЕНИЯ"
                prepend-icon="mdi-calendar"
                :rules="[(v) => !!v || 'Необходимо ввести дату']"
                readonly
                v-bind="attrs"
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="date"
              color="info"
              :active-picker.sync="activePicker"
              :max="
                new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
                  .toISOString()
                  .substr(0, 10)
              "
              min="1900-01-01"
              required
              @change="save"
            ></v-date-picker>
          </v-menu>
        </v-col>
      </v-row>
    </v-container>
    <v-container>
      <v-select
        :value="mychoise"
        :items="sourceItems"
        item-text="title"
        v-on:input="$emit('updateMychoise', ($event || '').trim())"
        :rules="rules.stdchoice"
        dense
        filled
        required
        :label="requestType"
      ></v-select>

      <v-text-field
        v-show="isCustomAbonement"
        :value="customAbonement"
        v-on:input="$emit('updateCustomAbonement', ($event || '').trim())"
        :rules="rules.customchoice"
        :counter="80"
        :placeholder="'ВВЕДИТЕ ' + requestType"
        filled
        dense
        clearable
        required
      ></v-text-field>
    </v-container>

    <v-container>
      <v-textarea
        :value="description"
        v-on:input="$emit('updateDescription', ($event || '').trim())"
        counter
        maxlength="1024"
        label="ПРОБЛЕМЫ СО ЗДОРОВЬЕМ"
        placeholder="ОПИШИТЕ ПРОБЛЕМЫ"
        :succes-messages="['Ok']"
        type="input"
        :rows="2"
        dense
        filled
        required
      ></v-textarea>
    </v-container>

    <v-container class="d-flex">
      <v-checkbox
        class="ma-auto"
        v-model="mydatasareverifyed"
        :rules="[() => mydatasareverifyed]"
        dense
      >
        <template v-slot:label>
          <div>
            ПОДТВЕРЖДАЮ, ЧТО ВСЕ ПРЕДОСТАВЛЕННЫЕ МНОЙ ДАННЫЕ<br />ДОСТОВЕРНЫ И
            ВЕРНЫ
          </div>
        </template>
      </v-checkbox>
    </v-container>
  </v-form>
</template>

<script>
import { format, parse } from "date-fns";
import { ru } from "date-fns/locale";

export default {
  name: "FormType4",
  props: {
    lastName: String,
    firstName: String,
    middleName: String,
    email: String,
    phone: String,
    description: String,
    birthday: String,
    mychoise: String,
    customAbonement: String,
    brokerLastName: String,
    brokerFirstName: String,
    brokerMiddleName: String,
    brokerEmail: String,
    brokerPhone: String,
    isAbonement: Boolean,
    info: Object,
  },
  emits: [
    "updateLastName",
    "updateFirstName",
    "updateMiddleName",
    "updateEmail",
    "updatePhone",
    "updateDescription",
    "updateBirthday",
    "updateCustomAbonement",
    "updateMychoise",
    "updateValid",
  ],

  data() {
    return {
      valid: false,
      model: null,
      activePicker: "YEAR",
      date: this.birthday,
      menu: false,
      index: 0,
      mydatasareverifyed: false,
      rules: {
        required: (v) => (v || "").trim().length > 0 || "Необходимо заполнить.",
        counter: (v) => (v || "").trim().length <= 40 || "Не более 40 символов",
        email: (value) => {
          const pattern =
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return pattern.test(value) || "Неверное имя e-mail";
        },
        phone: (value) => {
          const pattern =
            /^\+{0,1}(7|8){0,1}((-| |\(|\)){0,1}\d{3}){2}(-| |\)){0,1}(\d{2}(-| ){0,1}){2}$/;
          return pattern.test(value) || "Неверный номер телефона";
        },
        customchoice: [
          (v) =>
            !this.isCustomAbonement ||
            (v || "").trim().length > 0 ||
            "Необходимо заполнить поле",
        ],
        stdchoice: [
          (v) => !!v || "Необходимо заполнить поле",
          (v) => (v || "").trim().length > 0 || "Необходимо заполнить поле",
        ],
      },
    };
  },

  computed: {
    sourceItems() {
      if (this.isAbonement) return this.info.abonements;
      return this.info.certificates;
    },

    requestType() {
      if (this.isAbonement) return "АБОНЕМЕНТ";
      return "СЕРТИФИКАТ";
    },

    isCustomAbonement() {
      return this.mychoise !== null && this.mychoise === "ДРУГОЕ";
    },

    dateInfo() {
      const s = (this.date ?? "").length < 1 ? "2000-01-01" : this.date;
      const d = parse(s, "yyyy-MM-dd", new Date(2000, 1, 1));
      return format(d, "d MMMM yyyy", { locale: ru });
    },
  },
  watch: {
    menu(val) {
      val && setTimeout(() => (this.activePicker = "YEAR"), 100);
    },
    valid() {
      this.validateField();
      this.$emit("updateValid", this.valid);
    },
    isCustomAbonement() {
      this.validateField();
    },
  },

  methods: {
    save(d) {
      this.$refs.menu.save(d);
      this.$emit("updateBirthday", d);
    },
    validateField() {
      this.$refs.form.validate();
    },
  },
};
</script>
